import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  InputAdornment,
  TextField,
  useMediaQuery,
} from "@mui/material";
// import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Fragment, useEffect, useState } from "react";
import BotaoRelatorio from "../../../components/BotaoRelatorio";
import styles from "./styles.module.css";
import {
  buscaFiltroPorNome,
  deletaFiltro,
  exportarRelatorio,
  trazFiltrosPorIdFiltro,
  trazFiltrosPorIdRelatorio,
} from "../../../services/api-relatorios.service";
import MensagemSucesso from "../../../components/MensagemSucesso";
import MensagemErro from "../../../components/MensagemErro";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import WhiteButton from "../../../components/WhiteButton";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import BlueButton from "../../../components/BlueButton";
import { debounce } from "lodash";
import SearchIcon from "@mui/icons-material/Search";
import ExtractBtn from "./ExtractBtn";
import EditFilterBtn from "./EditBtn";

const FiltroSalvos = ({
  idRelatorio,
  codRelatorio,
  open,
  close,
  allowedButton,
}) => {
  const [openModal, setOpenModal] = useState(open || false);

  const [modalAlert, setModalAlert] = useState({
    open: false,
    msg: "",
    idFiltro: 0,
  });
  const [loading, setLoading] = useState();
  const [codigoRelatorio, setCodigoRelatorio] = useState();
  const [data, setData] = useState([]);

  const [snackBar, setSnackBar] = useState({
    error: false,
    sucess: false,
    msg: "",
  });

  const [searchText, setSearchText] = useState();
  const [filterData, setFilterData] = useState([]);
  const [responseDetalhes, setResponseDetalhes] = useState();

  const responsivUI = useMediaQuery("(min-width: 770px)");

  const dateRegex = /(\d{4})-(\d{2})-(\d{2})/;

  useEffect(() => {
    const inicializa = async () => {
      await handleGetData();
      setOpenModal(true);
    };
    open && inicializa();
  }, [open]);

  const handleGetData = async () => {
    try {
      const filtrosResponse = await trazFiltrosPorIdRelatorio(idRelatorio);
      setData(filtrosResponse.filtros);
      setFilterData(filtrosResponse.filtros);
    } catch (error) {
      handleSnackBar("error", error.response.data.mensagem);
    }
  };

  const handleDelete = async () => {
    try {
      const deleteResponse = await deletaFiltro(modalAlert.idFiltro);
      handleModalAlert();

      handleSnackBar("sucess", deleteResponse.mensagem);
    } catch (error) {
      handleSnackBar("error", error.response.data.mensagem);
    }

    await handleGetData();
  };

  const handleDebounce = async (searchText) => {
    try {
      if (searchText) {
        const responseSearch = await buscaFiltroPorNome(searchText);
        setFilterData(responseSearch.searchResult);
      } else {
        setFilterData(data);
      }
    } catch (error) {
      handleSnackBar("error", error.response.data.mensagem);
      setFilterData(data);
    }
  };

  const debouncedHandleChangeSearchText = debounce(handleDebounce, 500);

  const handleOpenModal = async () => {
    await handleGetData();

    setCodigoRelatorio(openModal ? codRelatorio : undefined);

    setOpenModal(!openModal);
  };

  const handleModalAlert = (msg, idFiltro) => {
    setModalAlert({
      open: !modalAlert.open,
      msg: !modalAlert.open ? msg : "",
      idFiltro,
    });
  };

  const handleCloseModal = () => {
    close();
    setOpenModal(false);
    setData([]);
    setFilterData([]);
  };

  const handleSnackBar = (type, msg = "") => {
    switch (type) {
      case "error":
        setSnackBar({ ...snackBar, error: true, msg });
        break;

      case "sucess":
        setSnackBar({ ...snackBar, sucesss: true, msg });
        break;

      case "close":
        setSnackBar({ ...snackBar, error: false, sucess: false, msg: "" });
        break;
    }
  };

  const handleSubmit = async (typeSubmit, idFiltro, nomdeDoFiltro) => {
    try {
      setLoading(true);
      let detalhes;
      try {
        const bodyFilter = await trazFiltrosPorIdFiltro(idFiltro);
        detalhes = bodyFilter.filtro.detalhes;
      } catch (error) {
        throw new Error(error.response.data.mensagem);
      }

      const responseArquivo = await exportarRelatorio(detalhes, typeSubmit);

      switch (typeSubmit) {
        case "csv":
        case "excel":
          if (responseArquivo.size) {
            const blob = new Blob([responseArquivo], {
              type: "text/csv;charset=utf-8",
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${nomdeDoFiltro}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            handleSnackBar("sucess", "Relatório gerado com sucesso!");
          } else {
            throw new Error(responseArquivo.mensagem);
          }
          break;

        case "PDF":
          if (responseArquivo.arquivoPdf) {
            const buffer = new Uint8Array(responseArquivo.arquivoPdf.data);
            const pdfBlob = new Blob([buffer], {
              type: "application/octet-stream",
            });

            const pdfUrl = window.URL.createObjectURL(pdfBlob);
            const linkDownloadPdf = document.createElement("a");

            linkDownloadPdf.href = pdfUrl;
            linkDownloadPdf.setAttribute("download", `${nomdeDoFiltro}.pdf`);

            document.body.appendChild(linkDownloadPdf);
            linkDownloadPdf.click();
            document.body.removeChild(linkDownloadPdf);
            window.URL.revokeObjectURL(pdfUrl);

            handleSnackBar("sucess", "Relatório gerado com sucesso!");
          } else {
            throw new Error(responseArquivo.mensagem);
          }
          break;

        case "AMBOS":
          if (responseArquivo) {
            const blob = new Blob([responseArquivo], {
              type: "application/zip",
            });

            const url = window.URL.createObjectURL(blob);
            console.log(url);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `${nomdeDoFiltro.replace(/\./g, "")}.zip`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            handleSnackBar("sucess", "Relatório gerado com sucesso!");
          } else {
            throw new Error(responseArquivo.mensagem);
          }
          break;
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);

      handleSnackBar("error", `${error}`);
    }
  };

  const styleButton = {
    border: "1px solid #18316E",
    borderRadius: "20px",
    color: "#18316E",
    "&:hover": {
      backgroundColor: "#d0daf5",
    },
  };

  const styleActionContainer = (twoButtons) => {
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: responsivUI
        ? twoButtons
          ? "space-between"
          : "flex-start"
        : "center",
      width: "100%",
      margin: "5px",
    };
  };

  const styleAutoComplete = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "50px",
      "& fieldset": {
        borderColor: "#18316e",
      },
      "&:hover fieldset": {
        borderColor: "#18316e",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#18316e",
      },
    },
  };

  return (
    <>
      {allowedButton && (
        <Button
          startIcon={<FilterAltOutlinedIcon />}
          sx={styleButton}
          onClick={handleOpenModal}
        >
          FILTROS
        </Button>
      )}
      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          <div className={styles.header}>
            <FilterAltOutlinedIcon
              sx={{ marginRight: "1rem", fontSize: "2rem" }}
            />
            <div className={styles.title}>Filtros</div>

            <TextField
              sx={styleAutoComplete}
              label="Buscar Filtros"
              id="outlined-start-adornment"
              onChange={(e) => {
                debouncedHandleChangeSearchText(e.target.value);
                setSearchText(e.target.value);
              }}
              value={searchText}
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "#18316e" }} />
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </DialogTitle>
        <DialogContent>
          {/* modal de filtros desktop */}

          {responsivUI ? (
            <>
              {filterData.length > 0 ? (
                //DESKTOP
                <table className={styles.accordion_table}>
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Dt. Criação</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filterData.map((row, index) => (
                      <Fragment key={index}>
                        <tr>
                          <td>{row.nomeDoFiltro}</td>
                          <td>
                            {new Date(row.createdAt)
                              .toISOString()
                              .slice(0, 10)
                              .replace(dateRegex, "$3/$2/$1")}
                          </td>
                          <td>
                            <div className={styles.button_action_container}>
                              <ExtractBtn
                                loading={loading}
                                typeRelatorio={(type) =>
                                  handleSubmit(
                                    type,
                                    row.idFiltro,
                                    row.nomeDoFiltro
                                  )
                                }
                              />
                              <EditFilterBtn
                                idFiltro={row.idFiltro}
                                codRelatorio={codRelatorio}
                                refreshFilters={handleGetData}
                              />

                              <button
                                className={styles.deleteBtn}
                                onClick={() =>
                                  handleModalAlert(
                                    `Você está apagando o filtro ${row.nomeDoFiltro}, tem certeza que gostaria de fazer isso?`,
                                    row.idFiltro
                                  )
                                }
                              >
                                <DeleteForeverRoundedIcon
                                  sx={{ color: "red", fontSize: "1.5rem" }}
                                />
                              </button>
                            </div>
                          </td>
                        </tr>
                      </Fragment>
                    ))}
                  </tbody>
                </table>
              ) : (
                <h3 className={styles.aviso_vazio}>Nenhum item encontrado!</h3>
              )}
            </>
          ) : (
            // MOBILE
            <div>
              <Grid container spacing={2} className={styles.container}>
                {filterData.map((item, index) => (
                  <Grid
                    item
                    sm={12}
                    lg={4}
                    md={6}
                    key={index}
                    className={styles.grid_container}
                  >
                    <div className={styles.card_container}>
                      <div className={styles.card_header}>
                        {item.nomeDoFiltro}
                      </div>
                      <div className={styles.card_content}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            flexDirection: "column",
                          }}
                        >
                          <p className={styles.card_text}>
                            <strong>Data:</strong>{" "}
                            {new Date(item.createdAt)
                              .toISOString()
                              .slice(0, 10)
                              .replace(dateRegex, "$3/$2/$1")}
                          </p>
                        </div>
                      </div>
                      <div className={styles.card_buttons}>
                        <ExtractBtn
                          loading={loading}
                          typeRelatorio={(type) =>
                            handleSubmit(type, item.idFiltro, item.nomeDoFiltro)
                          }
                        />
                        <EditFilterBtn
                          codRelatorio={codRelatorio}
                          idFiltro={item.idFiltro}
                          refreshFilters={handleGetData}
                        />
                        <button
                          className={styles.deleteBtn}
                          onClick={() =>
                            handleModalAlert(
                              `Você está apagando o filtro ${item.nomeDoFiltro}, tem certeza que gostaria de fazer isso?`,
                              item.idFiltro
                            )
                          }
                        >
                          <DeleteForeverRoundedIcon
                            sx={{ color: "red", fontSize: "1.5rem" }}
                          />
                        </button>
                      </div>
                    </div>
                  </Grid>
                ))}
              </Grid>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <div style={styleActionContainer(false)}>
            <WhiteButton
              textValue="Fechar"
              fullWidth
              contentIcon={<CloseRoundedIcon />}
              clickFunction={handleCloseModal}
            />
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={modalAlert.open}
        fullWidth
        onClose={() => handleModalAlert()}
      >
        <DialogContent>
          <span className={styles.alertModal}>{modalAlert.msg}</span>
        </DialogContent>
        <DialogActions>
          <div style={styleActionContainer(true)}>
            <WhiteButton
              textValue="Fechar"
              contentIcon={<CloseRoundedIcon />}
              clickFunction={() => handleModalAlert()}
            />

            <BlueButton
              textValue="Excluir"
              contentIcon={<DeleteForeverRoundedIcon />}
              clickFunction={handleDelete}
            />
          </div>
        </DialogActions>
      </Dialog>

      <MensagemSucesso
        open={snackBar.sucess}
        handleClose={() => handleSnackBar("close")}
        msg={snackBar.msg}
      />

      <MensagemErro
        open={snackBar.error}
        handleClose={() => handleSnackBar("close")}
        msg={snackBar.msg}
      />
    </>
  );
};

export default FiltroSalvos;
